function isRvoReason(reason) {
    return reason === 'RVO' || reason === 'RVO_UNAVAILABLE';
}

export default isRvoReason;
